<!--
 * @Description: 添加子账户
 * @Date: 2019-12-28 15:42:02
 * @LastEditTime: 2020-04-01 14:52:02
 -->
<template>
  <div id="createSubAccount">
    <el-dialog
      title="添加子账户"
      :visible.sync="visible"
      :close-on-click-modal="false"
      width="500px"
    >
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="110px"
      >
        <el-form-item label="账号" prop="username">
          <el-input
            v-model="form.username"
            autocomplete="off"
            clearable
            placeholder="请输入账号"
          />
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input
            v-model="form.email"
            autocomplete="off"
            clearable
            placeholder="请输入邮箱"
          />
        </el-form-item>
        <el-form-item v-if="accountType === 4" label="深度取证次数" prop="depthForensicAmount">
          <el-input
            v-model="form.depthForensicAmount"
            autocomplete="off"
            clearable
            placeholder="请输入深度取证次数"
          />
        </el-form-item>
        <el-form-item v-if="accountType === 4" label="使用期限" prop="endTime">
          <el-date-picker
            v-model="form.endTime"
            class="closing-date-wrap"
            type="date"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="请选择使用期限"
          />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            v-model="form.remark"
            autocomplete="off"
            type="textarea"
            :rows="3"
            :autosize="{ minRows: 2, maxRows: 4}"
            placeholder="请输入备注"
          />
        </el-form-item>
      </el-form>
      <div class="footer-btns-wrap">
        <el-button @click="visible = false">
          取消
        </el-button>
        <el-button type="primary" :loading="submitLoading" @click="handleSubmit">
          确定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import dayjs from 'dayjs'
import { validateSubAccount, validateSubEmail, validateDeepForensicNum } from '@/utils/validator'

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    addType: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      visible: false,
      form: {
        username: '',
        email: '',
        depthForensicAmount: '',
        remark: '',
        endTime: ''
      },
      rules: {
        username: [
          { required: true, message: '账号不能为空', trigger: 'blur' },
          { min: 6, max: 18, message: '请输入6-18位的账号名', trigger: 'blur' },
          { validator: validateSubAccount, trigger: 'blur' }
        ],
        email: [
          { required: true, message: '4~40个字符,其中必须包含@', trigger: 'blur' },
          { min: 4, max: 40, message: '4~40个字符,其中必须包含@', trigger: 'blur' },
          { validator: validateSubEmail, trigger: 'blur' }
        ],
        depthForensicAmount: [
          { required: true, message: '请输入深度取证次数', trigger: 'blur' },
          { validator: validateDeepForensicNum, trigger: 'blur' }
        ],
        endTime: [
          { required: true, message: '请设置子账户使用期限', trigger: 'blur' }
        ],
        remark: [
          { required: true, message: '请输入备注', trigger: 'blur' },
          { min: 1, max: 200, message: '备注最大长度为200', trigger: 'blur' }
        ]
      },
      pickerOptions: {
        disabledDate(date) {
          const currentDate = new Date(date).getTime()
          const yesterday = dayjs().subtract(1, 'day')
          const nextYear = dayjs().add(1, 'year')
          return currentDate > nextYear || currentDate < yesterday
        }
      }
    };
  },
  computed: {
    ...mapState({
      submitLoading: state => state.account.submitLoading
    })
  },
  watch: {
    value(newVal) {
      this.visible = newVal
    },
    visible(val) {
      if (!val) {
        this.$refs.form.resetFields();
      }
      this.$emit('input', val)
    },
  },
  mounted() {
    if (this.accountType === 4) {
      this.form.endTime = dayjs().add(3, 'month').format('YYYY-MM-DD hh:mm:ss')
    }
  },
  methods: {
    ...mapActions({
      create: 'account/create'
    }),
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.create(this.form).then(res => {
            if (res.data.status == 0) {
              this.visible = false
              this.$message({
                type: 'success',
                message: '添加成功',
                center: true
              })
            }
          })
        }
      });
    }
  }
};
</script>
<style lang="scss">
#createSubAccount {
  .el-dialog {
		position: absolute;
		top: 0;
		left: 50%;
		margin-left: -250px;
		z-index: 2;
	}
  .el-form {
    padding-right: 40px;
    margin-top: 10px;
  }
  .closing-date-wrap {
    width: 100%!important;
    .el-input__inner {
      padding-left: 30px!important;
    }
  }
  .footer-btns-wrap {
    margin-top: 15px;
    padding: 15px 0;
    text-align: center;
    .el-button {
      width: 88px;
      height: 32px;
      padding: 0;
      &+.el-button {
        margin-left: 50px;
      }
    }
  }
}
</style>
